import {Injectable} from '@angular/core';
import {Timezone} from './static-data/timezone';
import {TIMEZONES} from './static-data/timezones';

@Injectable({providedIn: 'root'})
export class TimezonesService {
  getTimezones(): Timezone[] {
    return TIMEZONES;
  }
}
